var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-layout"}},[_c('iFoodHeader'),_c('router-view',{staticClass:"container mt-5 pt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }